import React from "react"

import { BusinessCard, Wrapper } from "components"

const FeaturedBusiness = ({ business }) => (
  <Wrapper maxWidth={768 - 128}>
    <BusinessCard
      image={business.featuredPhoto}
      category={business.category}
      startDate={business.startDatetime}
      endDate={business.endDatetime}
      title={business.name}
      website={business.website}
      address={business.address}
      url={business.url}
      description={
        business.website &&
        `<h5><a href="${business.website}" target="_blank" rel="noopener noreferrer">VISIT WEBSITE</a></h5>`
      }
    />
  </Wrapper>
)

export default FeaturedBusiness
